<template>
  <div class="role-permission-matrix-cell">
    <div v-if="isButtonKind" class="button-access-cell">
      <el-checkbox
        :model-value="status !== 'none'"
        :disabled="mode === 'view'"
        @update:model-value="handleButtonAccessToggle"
      />
    </div>
    <div v-else class="screen-permission-cell">
      <PermissionSelectCell
        :model-value="modelValue"
        :status="status"
        :changed="changed"
        :options="options"
        :mode="mode"
        @update:model-value="emit('update:modelValue', $event)"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
  import { computed } from 'vue';
  import PermissionSelectCell from '@/pages/master/role-permission/PermissionSelectCell.vue';

  type PermissionValue = 'full' | 'edit' | 'view' | 'limited' | 'none';
  type PermissionOption = {
    value: PermissionValue;
    label: string;
  };

  const props = defineProps<{
    rowKind: 'screen' | 'button';
    modelValue: PermissionValue;
    status: PermissionValue;
    changed: boolean;
    options: PermissionOption[];
    mode: 'edit' | 'view';
    hideButtonAccess?: boolean;
  }>();

  const emit = defineEmits<{
    (e: 'update:modelValue', value: PermissionValue): void;
  }>();

  const isButtonKind = computed(() => props.rowKind === 'button');

  const handleButtonAccessToggle = (checked: boolean) => {
    if (props.hideButtonAccess) return;
    emit('update:modelValue', checked ? 'view' : 'none');
  };
</script>

<style scoped lang="scss">
  .role-permission-matrix-cell {
    width: 100%;
  }

  .button-access-cell {
    min-height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .screen-permission-cell {
    display: flex;
    flex-direction: column;
    gap: 2px;
  }

  .action-flags {
    font-size: 10px;
    color: #909399;
    text-align: center;
    line-height: 1.2;
    padding-bottom: 2px;
  }
</style>
